import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "accommodation-experiences" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "section-header" };
const _hoisted_4 = { class: "experience-title" };
const _hoisted_5 = { class: "experience-subtitle" };
const _hoisted_6 = { class: "carousel" };
const _hoisted_7 = {
    key: 0,
    class: "loading-state"
};
const _hoisted_8 = {
    key: 1,
    class: "error-state"
};
const _hoisted_9 = {
    key: 3,
    class: "empty-state"
};
const _hoisted_10 = {
    key: 4,
    class: "scroll-indicator"
};
const _hoisted_11 = { class: "scroll-track" };
const _hoisted_12 = {
    class: "scroll-progress",
    ref: "scrollProgress"
};
const _hoisted_13 = { class: "scroll-arrows" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AccommodationCard = _resolveComponent("AccommodationCard");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, _toDisplayString($props.title || 'Estos lugares para hospedarte en Bolivia ofrecen mucho más que solo un lugar para dormir'), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString($props.subtitle || '¿Sueñas con escapar a una cabaña en los Andes o disfrutar de un retiro lujoso? Intenta planificar tu viaje alrededor de una de estas experiencias únicas de alojamiento.'), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
                ($setup.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[8] || (_cache[8] = [
                        _createElementVNode("div", { class: "spinner" }, null, -1),
                        _createElementVNode("p", null, "Cargando experiencias de alojamiento...", -1)
                    ])))
                    : ($setup.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)),
                            _createElementVNode("p", null, _toDisplayString($setup.error), 1),
                            _createElementVNode("button", {
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => ($setup.loadAccommodations && $setup.loadAccommodations(...args))),
                                class: "retry-btn"
                            }, "Reintentar")
                        ]))
                        : ($setup.accommodationExperiences.length > 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "experiences-grid",
                                ref: "track",
                                onMousedown: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => ($setup.handleMouseDown && $setup.handleMouseDown(...args))),
                                onScroll: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => ($setup.updateScrollProgress && $setup.updateScrollProgress(...args))),
                                onTouchstart: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => ($setup.handleTouchStart && $setup.handleTouchStart(...args))),
                                onTouchmove: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => ($setup.handleTouchMove && $setup.handleTouchMove(...args))),
                                onTouchend: _cache[5] || (_cache[5] =
                                    //@ts-ignore
                                    (...args) => ($setup.handleTouchEnd && $setup.handleTouchEnd(...args)))
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.accommodationExperiences, (experience) => {
                                    return (_openBlock(), _createBlock(_component_AccommodationCard, {
                                        key: experience.id,
                                        image: $setup.getMainImage(experience),
                                        title: experience.title,
                                        location: experience.location,
                                        price: $setup.formatPrice(experience.price_per_night),
                                        description: experience.description,
                                        badge: experience.badge,
                                        to: { name: 'AccommodationDetail', params: { id: experience.id } }
                                    }, null, 8, ["image", "title", "location", "price", "description", "badge", "to"]));
                                }), 128))
                            ], 544))
                            : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[10] || (_cache[10] = [
                                _createElementVNode("i", { class: "fas fa-bed" }, null, -1),
                                _createElementVNode("p", null, "No hay experiencias de alojamiento disponibles en este momento", -1)
                            ]))),
                ($setup.accommodationExperiences.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, null, 512)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("button", {
                                class: "scroll-arrow scroll-left",
                                onClick: _cache[6] || (_cache[6] = ($event) => ($setup.scroll(-1)))
                            }, _cache[11] || (_cache[11] = [
                                _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
                            ])),
                            _createElementVNode("button", {
                                class: "scroll-arrow scroll-right",
                                onClick: _cache[7] || (_cache[7] = ($event) => ($setup.scroll(1)))
                            }, _cache[12] || (_cache[12] = [
                                _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
                            ]))
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ])
        ])
    ]));
}
